export class DialogBox{
    enable:boolean;
    title:string;
    message="";
    tagname:string;
    value:string;
    isValuefromScript=false;

}